interface StarsProps {
  value: number;
  max?: number;
  className?: string;
}

export default function Stars({ value, max = 5, className = "" }: StarsProps) {
  return (
    <span
      className={`inline-flex items-center gap-0.5 text-accent-500 ${className}`}
      aria-label={`评分 ${value} 分`}
    >
      {Array.from({ length: max }).map((_, i) => (
        <i
          key={i}
          className={i < Math.round(value) ? "ri-star-fill" : "ri-star-line"}
        />
      ))}
    </span>
  );
}